import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {connect} from 'react-redux';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxMission from '../../../../store/actionreducers/mission';
import {FuseAnimate, FusePageSimple} from '../../../../@fuse/index';
import MissionList from './MissionList';
import UecareAlertDialog from "../../../../components/UecareAlertDialog";
import { constDataDialogs } from "../../../../constants";
import UecareListHeader from "../../../../components/header/UecareListHeader";
import { IconButton, Icon, LinearProgress, Typography, TablePagination } from '@material-ui/core'
import DownloadMissions from "../../../../components/DownloadMission";
import FilterBars from "../../../../components/FilterBars";
import ReduxMissionType from "../../../../store/actionreducers/missionPriceType";
import KeywordSearchBar from "../../../../components/KeywordSearchBar";
import StatusService from "../../../../service/status"

const searchFieldOptions = [
    { displayText: '搜任務編號', searchField: 'mission.no'},
    { displayText: '搜病人姓名', searchField: 'requester_user.name'},
    { displayText: '搜醫師姓名', searchField: 'provider_user.name'},
    { displayText: '搜醫院名稱', searchField: 'institution.name'},
    { displayText: '搜預約日期', searchField: 'rm.date'}
]

class MissionsApp extends Component {
    state = {
        currentPage: 0,
        limit: 10,
        searchField: '',
        searchKeyword: '',
        filters: {},
        filterBars: [],
    }

    async getMissionPriceTypeOptions() {
        const { getMissionPriceTypes } = this.props
        const missionPriceTypes = await getMissionPriceTypes()
        const missionPriceTypesOptions = missionPriceTypes.map(mpt => {
            return { displayText: mpt.name, value: mpt.id }
        })
        missionPriceTypesOptions.push({ displayText: '全部', value: '' })
        return missionPriceTypesOptions
    }

    async getMissionStatusTypeOptions() {
        const statusList = await StatusService.listStatus()
        const statusOptions = statusList.filter(status => {
            return status.relate_table.includes('mission')
        }).map(status => {
            return { displayText: status.name, value: status.id }
        })
        statusOptions.push({ displayText: '全部', value: '' })
        return statusOptions
    }

    async initializeFilters(filterBars) {
        let tempFilters = {}
        filterBars.map(filter => {
            tempFilters[filter.value] = ''
        })
        this.setState({ filters: tempFilters })
        return tempFilters
    }

    async componentDidMount() {
        const missionPriceTypeOptions = await this.getMissionPriceTypeOptions()
        const missionStatusTypeOptions = await this.getMissionStatusTypeOptions()

        const filterBars = [
            {
                title: '任務類型',
                options: missionPriceTypeOptions,
                value: 'mission.fk_type_id',
            },
            {
                title: '任務狀態',
                options: missionStatusTypeOptions,
                value: 'mission.fk_status_id',
            }
        ]
        const filters = await this.initializeFilters(filterBars)
        this.setState({ filterBars, filters })
        await this._reload()
    }

    async onPageNumberChange(newPageNumber) {
        const { limit, searchField, searchKeyword, filters } = this.state
        const { getMissions } = this.props
        this.setState({ currentPage: newPageNumber})
        await getMissions({ limit, offset: newPageNumber*limit, searchField, searchKeyword, ...filters })
    }

    // on change the rows per page value at the footer dropdown
    async onLimitChange(newLimit) {
        const { searchField, searchKeyword, filters } = this.state
        const { getMissions } = this.props
        this.setState({ limit: newLimit, currentPage: 0 })
        await getMissions({ limit: newLimit, offset: 0, searchField, searchKeyword, ...filters })
    }

    // on change the filter options
    async onFiltersChange(field, value) {
        const { searchField, searchKeyword, limit, currentPage, filters } = this.state
        const { getMissions } = this.props

        const newFilters = { ...filters }
        newFilters[field] = value
        this.setState({ filters: newFilters})
        await getMissions({ limit, offset: currentPage*limit, searchField, searchKeyword, ...newFilters})
    }

    // on click one of the search buttons (each button indicates searching on different fields)
    async onClickSearchButton(searchField, searchKeyword) {
        const { limit, filterBars, filters } = this.state
        const { getMissions } = this.props

        if (searchField === '') {
            await this.initializeFilters(filterBars)
            await getMissions({ limit, offset: 0, searchField, searchKeyword })
        } else {
            await getMissions({limit, offset: 0, searchField, searchKeyword, ...filters})
        }
        this.setState({ searchField, searchKeyword, currentPage: 0 })
    }

    async _reload() {
        const { getMissions } = this.props
        const { limit, searchField, searchKeyword } = this.state
        this.setState({ isLoading: true })
        await getMissions({ limit, offset: 0, searchField, searchKeyword })
        this.setState({ isLoading: false })
    }

    render() {
        const { classes, openDataDialog, missions, numberOfRecords } = this.props
        const { limit, currentPage, searchField, filterBars, filters } = this.state

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <UecareListHeader title='任務列表' icon='assignment' reload={() => this._reload()} />
                    }
                    content={
                        <div>
                            <LinearProgress
                                color="secondary"
                                style={{ visibility: this.state.isLoading ? 'visible' : 'hidden' }}
                            />

                            <FilterBars
                                filterBars={filterBars}
                                onFilterSelected = {(field, value) => this.onFiltersChange(field, value)}
                                filters={filters}
                            />

                            <div className="flex justify-between items-center px-16 py-8">
                                <KeywordSearchBar
                                    searchFieldOptions={searchFieldOptions}
                                    searchField={searchField}
                                    onClickSearchButton={(searchField, searchKeyword) => this.onClickSearchButton(searchField, searchKeyword)}
                                />
                                <IconButton
                                    aria-label="download mission"
                                    onClick={async event => {
                                        try {
                                            event.stopPropagation()
                                            openDataDialog({
                                                type: constDataDialogs.type.edit,
                                                name: constDataDialogs.name.downloadMissions,
                                            })
                                        } catch (e) {
                                            console.warn('you got an error = ', e)
                                        }
                                    }}
                                >
                                    <Icon>get_app</Icon>
                                </IconButton>
                            </div>
                            <MissionList
                                missions={missions}
                                limit={limit}
                            />
                            <div className='flex flex-row justify-between items-center'>
                                <FuseAnimate animation="transition.slideLeftIn" delay={500}>
                                    <div className="flex items-center">
                                        <FuseAnimate animation="transition.slideLeftIn" delay={500}>
                                            <Typography className='pl-8'>
                                                {`總共 ${numberOfRecords} 筆資料`}
                                            </Typography>
                                        </FuseAnimate>
                                    </div>
                                </FuseAnimate>
                                <TablePagination
                                    component="div"
                                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                    count={numberOfRecords}
                                    onChangePage={(event, page) => this.onPageNumberChange(page)}
                                    page={currentPage}
                                    rowsPerPage={limit}
                                    onChangeRowsPerPage={(event) => this.onLimitChange(event.target.value)}
                                />
                            </div>
                        </div>
                    }
                    sidebarInner
                    onRef={instance => {
                        this.pageLayout = instance;
                    }}
                />

                <DownloadMissions/>
                <UecareAlertDialog/>
            </React.Fragment>
        )
    };
}

const styles = () => ({
    root: {},
    layoutHeader: {
        height: 160,
    },
    layoutContentCardWrapper: {
        padding: 16,
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMissions: ReduxMission.ActionCreator.getMissions,
        getMissionPriceTypes: ReduxMissionType.ActionCreator.getMissionPriceTypes,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        setMissionListPageNumber: ReduxMission.ActionCreator.setMissionListPageNumber,
        setSelectedTabValue: ReduxMission.ActionCreator.setSelectedTabValue,
    }, dispatch);
}

function mapStateToProps({mission: { list, numberOfRecords, selectedTabValue }, missionPriceType }) {
    return {
        missions: list,
        selectedTabValue,
        numberOfRecords,
        missionPriceTypes: missionPriceType.list,
    }
}
export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(MissionsApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/mission/MissionsApp.js